import React, { Component } from 'react'
import { connect } from 'react-redux'
import styled, { css } from 'styled-components';
import { Link, withRouter } from 'react-router-dom'
import { VelocityComponent } from 'velocity-react';

import { fetchSettings, getSettings, updateSettings } from '../../settings'
import { media, newMedia, width } from '../../styles/utils'
import { container, bgImage, bgIcon, padding, hoverState } from '../../styles/global';
import { opacify } from 'polished';

import logo from 'svg-react-loader?name=Icon!../../assets/images/nav-logo.svg';

const nav = [
    {
        label: 'Home',
        link: '/'
    },
    {
        label: 'Letters',
        link: '/letters'
    },
    {
        label: 'Resources',
        link: '/resources'
    },
    {
        label: 'Contact',
        link: '/contact'
    },
]


class Header extends Component<Props, State> {

    state = {
        pageLoaded: false,
        hovering: false,
        //cartActive: false,
    }

    componentDidMount() {
        const { fetchSettings } = this.props;

        // Fetch settings

        fetchSettings();

        // Fade out header after 5s

        if (!width.tabletLandscape()) {
            this.setState({
                hovering: true
            })
    
            setTimeout(() => {
                this.setState({
                    hovering: false
                })
            }, 5000)
        }
    }

    toggleMenu = () => {    
        const { menuActive } = this.state;
        
        this.setState({
            menuActive: !menuActive
        })
    }

    renderNav = () => {
        const { pageLoaded, hovering } = this.state;

        const items = nav.map((navItem, index) => {
            return (
                <NavItem
                    to={navItem.link}
                    key={index}
                >
                    {navItem.label}
                </NavItem>
            )
        })

        return (
            <Nav
                headerVisible={hovering}
            >
                {items}
            </Nav>
        )
    }

    toggleVisibility = (visible) => {
        if (!visible) {
            setTimeout(() => {
                this.setState({
                    hovering: visible
                })
            }, 1000);
    
        } else {
            this.setState({
                hovering: visible
            })
    
        }
    }

    render() {
        const { pageLoaded, hovering } = this.state;

        return (
            <Wrapper
                headerVisible={width.tabletLandscape() ? true : hovering}
                onMouseEnter={() => this.toggleVisibility(true)}
                onMouseLeave={() => hovering && this.toggleVisibility(false)}
            >
                <Container
                    headerVisible={width.tabletLandscape() ? true : hovering}
                >
                    <Link
                        to={'/'}
                    >
                        <Logo/>
                    </Link>
                    
                    {this.renderNav()}
                </Container>
            </Wrapper>
        )
    }
}

const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    flex: 1 0 auto;

    position: fixed;
    bottom: 0;
    left: 0;
    right: 0; 
    z-index: 10;
    box-shadow: 0 1px 10px 0 rgba(0,0,0,0.10);
    backface-visibility: visible;
    
    ${props => {
        if (!props.headerVisible) return css`
            box-shadow: 0 1px 10px 0 rgba(0,0,0,0);
        `
    }}

    ${media.tablet`
        display: none;
    `}
`

const Container = styled.div`
    ${container}
    ${padding}
    max-width: none;
    display: flex;
    justify-content: center;
    align-items: stretch;
    height: 60px;
    will-change: background;
    z-index: 12;
    width: 100%;
    box-sizing: border-box;
    transition: background 0.35s ease-out;
    backface-visibility: visible;

    ${props => {
        if (props.headerVisible) return css`
           background: white;
        `
    }}

    ${props => {
        if (!props.headerVisible) return css`
            background: transparent;
        `
    }}


    ${media.tabletLandscape`
        background: white !important;
    `}
`

const Logo = styled(logo)`
    position: absolute;
    top: 50%;
    left: 20px;
    transform: translateY(-50%);
    transition: background 0.35s ease-out;
    height: 32px;
    width: 32px;
    z-index: 2;
`

const Nav = styled.div`
    display: flex;
    flex: 1;
    max-width: 1000px;
    opacity: 1;
    transition: opacity 0.35s ease-out;
    transform: translate3d(0,0,0);

    ${props => {
        if (!props.headerVisible) return css`
            opacity: 0;
        `
    }}

    ${media.tabletLandscape`
        opacity: 1 !important;
    `}
`;

const NavItem = styled(Link)`
    flex: 1;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;

    font-family: Platform-Light;
    font-size: 14px;
    color: #4E4E4E;
    letter-spacing: 1.58px;
    text-transform: uppercase;
    transition: background 0.15s ease;
    
    &:not(:first-child) {
        box-shadow: -1px 0 0 0 #F0F0F0;
    }

    &:hover {
        background: #FAFAFA;
    }

    ${props => {
        if (props.active) return css`
            font-family: 'Platform-Regular';
            background: #FAFAFA;
        `
    }}

    ${media.tablet`
        font-size: 12px;
    `}
`;

const mapDispatchToProps = dispatch => ({
    fetchSettings() {
        dispatch(fetchSettings())
    },
    updateSettings(setting) {
        dispatch(updateSettings(setting))
    },
})

const mapStateToProps = (state, props) => ({
    settings: getSettings(state),
})

export default connect(mapStateToProps, mapDispatchToProps)(Header);



// WEBPACK FOOTER //
// ./client/components/Header/Header.js